'use client';

import { ButtonV1 } from '@northladder/design-system';
import { useTranslations } from '@northladder/i18n';

import { HeroImageSlider } from './HeroImageSlider';

interface IAssessmentReadyToBeginProps {
  /**
   * Callback to start the assessment.
   */
  onStart: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * This is displayed when the user is ready to begin the assessment, as soon as
 * the evaluationId is validated & available in the session.
 */
export function AssessmentReadyToBegin({
  onStart,
}: IAssessmentReadyToBeginProps) {
  const t = useTranslations('WelcomePage');

  return (
    <div className="mx-auto px-4 text-center sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-3xl flex-col items-center pb-4">
        <HeroImageSlider />
        <h1 className="text-body-text pt-8 text-2xl font-bold">
          {t('welcome')}
        </h1>

        <h1
          className="
            text-primary-600 dark:text-primary-400 pt-4 text-lg font-normal
            tracking-tight sm:text-xl
          "
        >
          {t('subTitle')}
        </h1>

        <p
          className="
            text-primary-700 dark:text-primary-300 max-w-xl pt-2 text-base font-normal
          "
        >
          {t('description')}
        </p>
        <div className="pt-12">
          <ButtonV1
            className="text-md animate-pulse px-12"
            label={t('btnCTA')}
            onClick={onStart}
            type="button"
          />
        </div>
      </div>
    </div>
  );
}
